import { render, staticRenderFns } from "./dashboard_ports.vue?vue&type=template&id=54d689f2&"
import script from "./dashboard_ports.vue?vue&type=script&lang=js&"
export * from "./dashboard_ports.vue?vue&type=script&lang=js&"
import style0 from "./dashboard_ports.vue?vue&type=style&index=0&id=54d689f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAlert,VBtn,VBtnToggle,VCard,VCardSubtitle,VCardText,VCardTitle,VProgressLinear,VSelect})
